/**
 * 获取支付特权信息
 */
// import { getIntl } from '@/locales';
// const intl = getIntl();
import {
  CardStatus,
  CardType,
  DEVICE_TYPE,
  GetCardRulesReturnType,
  GetOrderDetailReturnType,
  PayInfoSource,
  PayStatusEnum,
} from '@/types';

export type GetPayPrivilegeInfoResultType = {
  privileges: PrivilegeType[];
  warningInfo: string;
  preferCouponInfo: PreferCouponInfo;
  refundFlag: FirstShowFlag;
  filfulFlag: FirstShowFlag;
  payTools: PayToolType[];
  cards?: CardElementType[];
};

export interface PayToolType {
  allow: boolean;
  payFlag: boolean;
  payToolId: string;
  payToolPlatformType: string;
  payToolCode: string;
  feeUncharged: boolean;
  feeUnchargedProduct: string;
  payToolName: string;
  payToolFrontName: string;
  paymentConfigId: number;
  paymentMethodCode: string;
  cardRechargeFlag: boolean;
}

interface PreferCouponInfo {
  totalTicketPrivilegePrice: string;
  totalGoodsPrivilegePrice: string;
  privilegeTotalPrice: string;
  canUseCoupon: boolean;
  preferCoupons: PreferCouponType[];
}
export interface PreferCouponType {
  limitValue: number;
  exchangeQuantity: number;
  templateCode: number;
  useType: Type;
  filmNameList: any[];
  concreteProductType: Type;
  expireTime: number;
  couponType: CouponType;
  name: string;
  startTime: number;
  isPrefer: string;
  state: string;
  couponCode: string;
  discountValue: number;
  goodsNameList: any[];
  birthdayShow: string;
  compensateRule?: number;
  exchangePolicy?: string;
  compensatePrice?: string;
  seatCode?: string;
}
enum Type {
  Common = 'COMMON',
  Ticket = 'TICKET',
}

enum CouponType {
  DiscountCoupon = 'DISCOUNT_COUPON',
  ExchangeVoucher = 'EXCHANGE_VOUCHER',
  RepriceCoupon = 'REPRICE_COUPON',
}
export interface PrivilegeType {
  activityInfos?: ActivityInfo[];
  payMethod: string;
  privilegeTotalPrice: string;
  cardInfos: CardInfosType[];
  privilegeDescription: string;
  privilegeType: string;
  ticketCost: string;
  ticketInfos: TicketInfo[];
  /** 票展示列表 */
  ticketList: TicketListType[];
  goodsInfos?: GoodsInfosType[];
  /** 商品展示列表 */
  goodsList?: GoodsListType[];
  originalTicketTotalPrice: string;
  privilegeTitle?: string;
  timeId: string;
  [key: string]: any;
}

export interface GoodsInfosType {
  activityId: string;
  privilegeTagId: string;
  goodsCount: number;
  privilegeTag: string;
  category?: any;
  /**
   * 优惠后价格
   */
  goodsPrivilegePrice: string;
  goodsId: string;
  /**
   * 原价
   */
  goodsOriginalPrice: string;
  goodsName: string;
  /** 优惠类型 */
  privilegeType?: string;
}

export interface GoodsListType extends GoodsInfosType {
  quantity: string;
  goodsSinglePrivilegePrice: string; // 单个优惠价
  goodsSingleOriginalPrice: string; // 单个原价
}
export interface TicketListType {
  /** 票类型 */
  ticketTypeName: string;
  ticketTypeId: string;
  /** 票张数 */
  ticketCount: number;
  /** */
  privilegeTagId: string;
  ticketPrivilegePrice: string;
  /** 票价 - 如果存在服务费则减去服务费-[独立拿出来显示] */
  ticketOriginalPrice: string;
  ticketCost: string;
  /** 用于核销会员码 */
  activityExtended: string;
}

interface ActivityInfo {
  activityId: string;
  activityName: string;
  activityTag: string;
  checkBankCardNo: boolean;
  introduction: string;
  /** 兑换码 */
  promotionNum?: string;
}

interface TicketInfo {
  activityId?: string;
  privilegeTagId?: string;
  privilegeTag: string;
  ticketOriginalPrice: string;
  ticketPrivilegePrice: string;
  ticketCount: number;
  seatId: string;
  ticketTypeId: string;
  ticketTypeName: string;
  remainAgentFee: string;
  serviceFee?: string;
  privilegeType?: string;
  ticketCost?: string;
}
/**
 * 保存本地订单信息
 */
export interface OrderObjType {
  map: Map;
  film: Film;
  picture: Picture;
  schedule: Schedule;
  shop: Shop;
  pos: Pos;
  order: (WelcomeOrder & GetOrderDetailReturnType) & {};
  captche: Captche;
  seat: Seat;
  card: GetCardRulesReturnType;
  getPayInfo: GetPayInfo;
  payInfo: PayInfo;
  openid: string;
  authOpenid: string;
  templateId: null;
  stamp: null;
  store: Store;
  supportCinemas: any[];
  channelSetting: null;
  riskParams: RiskParams;
  riskControlSwitch: boolean;
  newAddCoupon: NewAddCoupon;
  activity: Activity;
  nowLevel: NowLevel;
  loginReturnUrl: string;
  invoice: Invoice;
  systemRouter: SystemRouter;
  referee: Referee;
  goodsDetailInfo: GoodsDetailInfo;
  TFB: Tfb;
  /**支付工具列表 */
  payTools: PayToolType[];
  privileges: PrivilegeType[];
  currencySign: {
    cinemaLinkId: string;
    currencySignCode: string;
    currencySign: 'MOP' | '$' | '¥';
    timeZone: string;
    language: 'zh_TW' | 'zh' | 'en';
    region: string;
    supportLanguages: {
      languageCode: 'zh_TW' | 'zh' | 'en';
      languageName: string;
    }[];
  };
  [key: string]: any;
}

export interface Tfb {
  userId: string;
}

export interface Activity {
  activityViewCode: string;
  activityViewType: string;
  activityViewName: string;
  finalTitleImgUrl: string;
  finalBgImgUrl: string;
}

export interface Captche {
  quickLogin: boolean;
  register: boolean;
  reset: boolean;
  unbind: boolean;
  resetCardPwd: boolean;
  setCardPwd: boolean;
  openAuthLogin: boolean;
}

enum FilmVersion {
  Imax2D = 'IMAX2D',
  Imax3D = 'IMAX3D',
  The2D = '2D',
}

interface Film {
  id: string;
  name: string;
  directors: string;
  rating: string;
  showStatus: string;
  showDate: string;
  cinemaLinkId: string;
  actors: string;
  filmUniqueId: string;
  customRating: string;
  filmEnName: string;
  filmId: string;
  filmName: string;
  poster: string;
  introduction: string;
  filmLevel: string;
  filmVersion: FilmVersion;
  privilegeTags: PrivilegeTag[];
  country: string;
  horizontalPoster: string;
  largeStills: string[];
  duration: number;
  filmTypeName: string;
  plot: string;
  filmTrailer: string;
  stills: string[];
  filmLang: string;
  dates: DateElement[];
  filmShortNameEn: string;
  filmCinemaLinkId: string;
}

interface DateElement {
  date: string;
  schedules: Schedule[];
  dateTag: string;
}
// enum FilmLang {
//   中文 = intl.formatMessage({ id: 'iWeb.types.seat.Chinese', defaultMessage: '中文' }) as unknown as FilmLang,
//   原聲 = intl.formatMessage({ id: 'iWeb.types.seat.OriginalSound', defaultMessage: '原聲' }) as unknown as FilmLang,
//   英語 = intl.formatMessage({ id: 'iWeb.types.seat.English', defaultMessage: '英語' }) as unknown as FilmLang,
// }
interface PrivilegeTag {
  shortActivityTag: string;
  shortActivityTagId: string;
}

export interface GetPayInfo {
  privileges: PrivilegeType[];
  cards?: CardElementType[];
  warningInfo: string;
  preferCouponInfo: PreferCouponInfo;
  refundFlag: FirstShowFlag;
  filfulFlag: FirstShowFlag;
  payTools: PayTool[];
}

interface PayTool {
  payToolId: string;
  payToolPlatformType: string;
  payToolCode: string;
  feeUncharged: boolean;
  feeUnchargedProduct: string;
  payToolName: string;
  payToolFrontName: string;
}
export interface CardElementType {
  cardAmount: number;
  amount: number;
  rechargeExpireTimeUnit: string;
  cardName: string;
  createAmt?: number | string;
  membershipFee?: number | string;
  validDate: number;
  cardCost: number;
  cardType: CardType;
  rechargeMin: number;
  gmtCreate: number;
  cardNo: string;
  cinemaLinkId: string;
  ruleCode: number;
  accountId: string;
  balance: number;
  canChargeFlg: string;
  cardRequireList: string[];
  leaseCode: string;
  rechargeExpireMonth: number;
  id: number;
  canOperTypeList: string[];
  rechargeExpireTime: number;
  cardNumber: string;
  cardStatus: CardStatus;
  expireDesc?: string;
}
export interface CardInfosType {
  cardType: CardType;
  cardDiscount: string;
  cardNumber: string;
}

type FirstShowFlag = string;

export interface GoodsDetailInfo {
  goodsId: string;
  hasTicketPackage: boolean;
  categoryType: string;
  maxCanBuy: number;
}

export interface Invoice {
  invoiceContent: string;
  invoiceTotalAmount: number;
  invoicePosTicketNum: string;
  invoiceOrderIds: any[];
  invoiceOrderType: string;
  invoiceChannelType: string;
  invoiceNeedUpload: boolean;
  invoiceOrderDetail: any[];
  invoiceOrderImgs: any[];
  invoiceSelectedCinemaLinkId: string;
}

export interface Map {
  city: string;
  change: boolean;
}

export interface NewAddCoupon {
  couponCode: string;
  comeFrom: string;
}

export interface NowLevel {
  levelId: number;
  levelCode: string;
  levelName: string;
  growthDisplayName: string;
}

export interface WelcomeOrder {
  id: string;
  type: string;
  orderId?: string;
  orderType?: string;
  orderStatus: string;
  cinemaAddress: string;
  cinemaLinkId: number;
  cinemaPhoneNumber: string;
  cinemaName: string;
  ticketInfo: TicketInfo2;
  notice: string;
  channelCode: string;
  servicePhone: string;
  mobile: number;
  paymentList: PaymentList[];
  originAmount: number;
  totalAmount: number;
  createTime: number;
  cinemaLogo: string;
  refundFlag: string;
  [key: string]: any;
}

export interface PaymentList {
  paymentMethodCode: string;
  genericMethodName: string;
  resultCode: string;
  genericPayType: string;
  sort: number;
  resultMsg: string;
  payAmount: number;
  payStatusEnum: string;
  success: boolean;
  returnUrl: string;
  payCode: string;
  key: string;
}

export interface TicketInfo2 {
  ticketList: TicketList[];
  orderId: string;
  orderStatus: PayStatusEnum;
  showDate: number;
  filmCd: number;
  duration: number;
  hallCode: number;
  confirmationId: number;
  filmLanguage: string;
  scheduleId: number;
  filmVersion: string;
  channelCode: string;
  ticketCount: number;
  ticketPrice: number;
  createDateTime: number;
  paymentList: PaymentList[];
  filmUniqueId: number;
  lockOrderId: number;
  filmName: string;
  hallName: string;
  seatNames: string;
}

export interface TicketList {
  serviceFee: number;
  ticketPrice: number;
  columnId: number;
  printFlag: string;
  sectionCode: number;
  rowId: number;
  sectionName: string;
  ticketNo: number;
  ticketStatus: string;
  seatCode: string;
  ticketFee: number;
}
/**
 * @desc PayInfo支付信息
 * @originalTicketTotalPrice  票订单原价
 * @originalGoodsTotalPrice  卖品单原价
 * @originalTotalPrice  整个订单原价
 * @privilegeTotalPrice  整个订单优惠价
 * @eselectedCouponsum  选择使用的优惠券
 * @priceDiff  整个订单优惠了多少钱
 * @privilegeType  优惠类型
 * @priceDiff  整个订单优惠了多少钱
 * @ticketList  票列表
 * @privilege  优惠信息
 * @payStatus  订单信息状态 NONE是还未创建订单的
 * @NULL  未知初始
 */
export interface PayInfo {
  payMethod?: string;
  privilegeIndex?: number;
  toolIndex?: string;
  tool?: string;
  toolType?: string;
  payStatus?: PayInfoSource;
  privilege?: string;
  totalPrice?: number;
  cost?: number;
  totalTicketServiceFee?: number;
  originalTicketTotalPrice?: number | string;
  originalGoodsTotalPrice?: number;
  originalTotalPrice?: number;
  selectedCoupons?: any[];
  couponsDiscount?: number;
  privilegeDiscount?: number;
  privilegeTotalPrice?: number | string;
  originalPricePrivilegeIndex?: number;
  privilegeDescription?: string;
  priceDiff?: number;
  privilegeType: string;
  ticketPrivilegePrice?: number;
  sourcePayments?: string;
  ticketInfos?: TicketInfo[];
  goodsInfos?: GoodsInfosType[];
  /** 自定义数据 - [用于展示] */
  ticketList?: TicketListType[];
  goodsList: GoodsListType[];
  //
  curPrivilege?: PrivilegeType;
  /**
   * 新增自定义字段
   * 1. 价格字段
   */
  // 票优惠价格
  ticketPriceDiff?: number;
  // 卖品优惠价格
  goodsPriceDiff?: number;
  canUseCoupon?: boolean;
  // 会员码
  memberNumber?: any;
  [key: string]: any;
}

export interface PrivilegeType {
  activityInfos?: ActivityInfo[];
  payMethod: string;
  privilegeTotalPrice: string;
  cardInfos: CardInfosType[];
  privilegeDescription: string;
  privilegeType: string;
  ticketCost: string;
  ticketInfos: TicketInfo[];
  /** 票展示列表 */
  ticketList: TicketListType[];
  goodsInfos?: GoodsInfosType[];
  /** 商品展示列表 */
  goodsList?: GoodsListType[];
  originalTicketTotalPrice: string;
  privilegeTitle?: string;
  timeId: string;
  [key: string]: any;
}
export interface CardInfosType {
  cardType: CardType;
  cardDiscount: string;
  cardNumber: string;
}

export interface GoodsInfosType {
  activityId: string;
  privilegeTagId: string;
  goodsCount: number;
  privilegeTag: string;
  /**
   * 优惠后价格
   */
  goodsPrivilegePrice: string;
  goodsId: string;
  /**
   * 原价
   */
  goodsOriginalPrice: string;
  goodsName: string;
  /** 优惠类型 */
  privilegeType?: string;
}
export interface GoodsListType extends GoodsInfosType {
  quantity: string;
  goodsSinglePrivilegePrice: string; // 单个优惠价
  goodsSingleOriginalPrice: string; // 单个原价
}
export interface TicketListType {
  /** 票类型 */
  ticketTypeName: string;
  ticketTypeId: string;
  /** 票张数 */
  ticketCount: number;
  /** */
  privilegeTagId: string;
  ticketPrivilegePrice: string;
  /** 票价 - 如果存在服务费则减去服务费-[独立拿出来显示] */
  ticketOriginalPrice: string;
  ticketCost: string;
  /** 用于核销会员码 */
  activityExtended: string;
}
export interface Picture {
  title: string;
  picList: any[];
  showIndex: number;
}

export interface Pos {
  goodsParamsJson: any[];
  packageGoodsInfo: boolean;
  standardPrice: number;
  totalNumber: number;
  totalPrice: number;
}

export interface Referee {
  empCode: string;
  leaseCode: string;
}

export interface RiskParams {
  csessionid: string;
  sig: string;
  nc_token: string;
  nc_scene: string;
}

export interface Schedule {
  scheduleId: string;
  scheduleKey: string;
  hallId: string;
  hallName: string;
  dateText: string;
  showTime: string;
  startTime: string;
  endTime: string;
}

export interface Seat {
  seatList: any[];
  seatIds: string;
  seatIdList: any[];
  seatNameList: any[];
  lockOrderId: string;
  expireIn: number;
  sectionIndex: number;
  scheduleId: string;
}

export interface Shop {
  goods: GetPayInfo;
  cards: GetPayInfo;
}

export interface Store {
  myPoint: number;
  goods: Goods;
  order: StoreOrder;
}

export interface Goods {
  id: string;
  name: string;
}

export interface StoreOrder {
  orderId: string;
  orderType: string;
  orderStatus: string;
  merchandiseName: string;
  consumePoint: string;
}

export interface SystemRouter {
  his: string;
  now: string;
}

/**
 * 创建-首次-支付订单
 */
export interface CreateTicketOrderParamsType {
  /** 区域代码 */
  countryCode: string;
  /** 锁单id  */
  lockOrderId: string;
  /** 场次 */
  scheduleKey: string;
  scheduleId: string;
  /** 设备 */
  device?: DEVICE_TYPE;
  // 信息未明
  /** 票的信息
   * [{"seatId":"000000000046-5-5","activityId":"ubuoksm3hjck","ticketTypeId":"-3","ticketTypeName":"成人票"}]
   */
  tickets: string;
  goodsParamsJson?: string;
  // 两个价格未明
  /** 总原价 */
  totalPrice: string | number;
  /** 总现价 */
  payAmount: string;

  /** 支付
   * "[{"payMethod":"M_PAY_WECHAT","payToolId":"3","returnPayUrl":"https://pre-site.icirena.ai/pay/complete.html?wapid=HGZYYZZH_H5_PROD_S_MPS","openId":""}]"
   */
  payments: string;

  phone: string;
  email: string;
  version?: string;
}
export interface PaymentsType {
  /** 支付方式 */
  payMethod: string;
  /** 支付工具id 可能是卡 所以可能不存在 */
  payToolId?: string;
  /** 支付完成后返回地址 */
  returnPayUrl?: string;
  /** openid 微信专属 */
  openId?: string;
  /** 储值卡id */
  payCardNumber?: string;
}

export interface GetAccountLevelRulesReturnType {
  growthDesc: string;
  memberDesc: string;
  allLevels: AllLevel[];
  growthRules: GrowthRule[];
  growthDisplayName?: string;
}

export interface AllLevel {
  levelCode: string;
  nextLevelRuleGrowthValue: number;
  levelRuleGrowthValue: number;
  levelId: string;
  rights: Right[];
  levelName: string;
}

export interface Right {
  rightsName: string;
  rightsType: string;
  rightsDesc?: string;
  levelId: string;
  rightsTypeDesc: string;
}

export interface GrowthRule {
  growthScore: string;
  growthType: string;
  growthTypeDesc: string;
  growthOpeartion: string;
  growthDesc?: string;
}
